import { useEffect, useState, useRef, useCallback } from 'react';
import { queryDriverGPSInfo } from '../js/request';
import { DRAW_MAP_INTERVAL_TIME } from '../js/constant';

interface Props {
  orderNumber: string;
  queryState?: number; // 查询状态，1：查询， 0：不查询
}

interface IGPSType {
  driverLng: string;
  driverLat: string;
}

const INIT_GPS_INFO = { driverLng: '', driverLat: '' };

export default function useQueryDriverGPSInfoHook(props: Props) {
  const { orderNumber, queryState = 0 } = props;
  const [gpsInfo, setGPSInfo] = useState<IGPSType>(INIT_GPS_INFO);
  const intervalTimer = useRef(0);

  const loadOrderList = useCallback(() => {
    queryDriverGPSInfo({ orderNumber })
      .then(ret => {
        if(ret) {
          setGPSInfo(ret);
        }
      })
  }, [orderNumber])

  // 轮询更新数据
  useEffect(() => {
    if (!orderNumber || !queryState) return;
    intervalTimer.current = window.setInterval(() => {
      loadOrderList()
    }, DRAW_MAP_INTERVAL_TIME * 1000);
    return () => {
      if (intervalTimer.current) {
        clearInterval(intervalTimer.current);
      }
    }
  }, [loadOrderList, queryState, orderNumber])

  useEffect(() => {
    if (!orderNumber || !queryState) return;
    loadOrderList();
  }, [orderNumber, queryState, loadOrderList])

  // 切换工单后，重置 gps 数据
  useEffect(() => {
    setGPSInfo(INIT_GPS_INFO);
  }, [orderNumber, queryState])

  return {
    gpsInfo
  };
}